import React from 'react';
import './style.scss';

export default function ButtonCommon({
  variant = 'primary',
  content = '',
  icon,
  onClick,
  disabled = false,
  className = '',
  style = {},
  htmlType = 'button',
  ...restProps
}) {
  const variantMap = {
    primary: 'btn-primary-common',
    outline: 'btn-outline-common',
    'outline-danger': 'btn-outline-danger-common',
    danger: 'btn-danger-common',
  };
  const btnClass = variantMap[variant] || 'btn-primary-common';
  const combinedClassName = `${btnClass}${className ? ` ${className}` : ''}`;

  return (
    <button
      type={htmlType}
      className={combinedClassName}
      onClick={onClick}
      disabled={disabled}
      style={style}
      {...restProps}
    >
      {icon && <span className="btn-icon-common">{icon}</span>}
      {content}
    </button>
  );
}
